/**
 * Curse Hediye — tek hediye kuralı, adet kilidi (Liquid), 4000 TL, checkout koruma, PC sidebar
 */
(function () {
  'use strict';

  /** Snippet ile aynı hediye variant ID listesi (güncelleme sıfırlama için referans) */
  var CURSE_GIFT_VARIANT_IDS = ['67958040363374', '53366561112430', '53366569173358', '53262353170798'];
  var CURSE_GIFT_TOWEL_ID = '67958040363374';

  var nf = window.fetch.bind(window);
  var skipGiftCartHook = 0;
  /** Hediye satırını değiştirme sırasında: applyCartState / fetch hook ile yeniden tetik döngüsünü engelle */
  var _curseGiftReplacingBusy = 0;

  var _cartDrawerWasOpen = false;
  var _applyingCartUi = false;
  var _pendingApplyCartState = false;

  function thresholdCents() {
    var n = Number(window.curseGiftThreshold);
    return Number.isFinite(n) && n > 500 ? n : 400000;
  }

  function premiumThresholdCents() {
    var n = Number(window.curseGiftPremiumThreshold);
    return Number.isFinite(n) && n > 500 ? n : 800000;
  }

  function isPremiumGiftVariant(vid) {
    return String(vid) === CURSE_GIFT_TOWEL_ID;
  }

  function cartTotalCents(cart) {
    return Number(cart.total_price != null ? cart.total_price : cart.items_subtotal_price || 0);
  }

  function giftRoot() {
    return document.getElementById('curse-gift-selector');
  }

  /** Section swap / renderContents sonrası .loaded yoksa kök opacity: 0 — mobil panel görünmez kalır */
  function curseGiftHydrateRoot() {
    var root = giftRoot();
    if (root && !root.classList.contains('loaded')) {
      root.classList.add('loaded');
    }
  }

  function isCartDrawerOpen() {
    var el = document.querySelector('cart-drawer');
    return !!(el && el.classList.contains('active'));
  }

  function isDesktopGift() {
    return typeof window.matchMedia === 'function' && window.matchMedia('(min-width: 1024px)').matches;
  }

  /**
   * Sepet sütununun sol kenarına yapışık kenetlenme: viewport sağından ölçü (scrollbar / subpixele karşı vw birleştirilir).
   * #CartDrawer solu ≥ .drawer__inner ise max alınarak hediye paneli sağa çekilir; +DOCK_BIAS px bitişik kenetleme.
   */
  var CURSE_DOCK_BIAS_PX = 5;

  function syncCurseCartDrawerWidth() {
    var cd = document.getElementById('CartDrawer');
    var inner = cd && cd.querySelector('.drawer__inner');
    if (!cd || !inner) return;
    var r = inner.getBoundingClientRect();

    var vv = window.visualViewport;
    var vw =
      vv && typeof vv.width === 'number' && vv.width > 0
        ? vv.width
        : document.documentElement && document.documentElement.clientWidth > 0
          ? document.documentElement.clientWidth
          : window.innerWidth;

    var fromInner = vw - r.left;
    var fromRight = fromInner > 0 ? Math.ceil(fromInner) : 0;

    var cdRect = cd.getBoundingClientRect();
    if (
      cdRect.width > 0 &&
      cdRect.width < vw * 0.75 &&
      cdRect.left >= 48 &&
      Number.isFinite(vw - cdRect.left)
    ) {
      fromRight = Math.max(fromRight, Math.ceil(vw - cdRect.left));
    }

    /* Ölçü sepet kolonundan küçük kalınca ara boşluk oluşuyordu; birkaç px sağa yaslar. */
    if (fromRight > 0 && fromRight < vw) {
      fromRight = Math.min(vw - 1, fromRight + CURSE_DOCK_BIAS_PX);
      cd.style.setProperty('--curse-cart-drawer-width', fromRight + 'px');
    }
  }

  var _curseDrawerWidthTimer;
  function scheduleSyncCurseCartDrawerWidth() {
    clearTimeout(_curseDrawerWidthTimer);
    _curseDrawerWidthTimer = setTimeout(syncCurseCartDrawerWidth, 60);
  }

  function purgeGiftPanelLocks() {
    try {
      document.body.classList.remove('curse-gift-open', 'gift-panel-open');
      document.documentElement.classList.remove('curse-gift-open');
    } catch (e) {}
  }

  /** Hediye açıkken Harcadıkça Kazan FAB kümesi — tüm yığını gizleme. */
  function setTierFabHiddenDuringGiftPanel(hide) {
    var ids = document.getElementById('CartDrawer-TierDiscountFabCluster');
    if (ids) {
      if (hide) ids.classList.add('hidden');
      else {
        ids.classList.remove('hidden');
        try {
          ids.style.removeProperty('display');
        } catch (e1) {}
      }
    }
    document.querySelectorAll('.curse-cart-fab-stack .tier-discount-fab-cluster').forEach(function (node) {
      if (hide) node.classList.add('hidden');
      else {
        node.classList.remove('hidden');
        try {
          node.style.removeProperty('display');
        } catch (e2) {}
      }
    });
  }

  function setGiftActive(on) {
    try {
      window.__curseGiftPanelShouldStayOpen = !!on;
    } catch (e0) {}

    var root = giftRoot();
    if (!root) return;
    curseGiftHydrateRoot();
    root.setAttribute('data-active', on ? 'true' : 'false');
    var sb = root.querySelector('.curse-gift-sidebar');
    var drawer = root.querySelector('.curse-gift-drawer');

    if (on) {
      root.classList.add('curse-gift-panel-open');

      if (isDesktopGift()) {
        if (drawer) drawer.classList.remove('active');
        if (sb) {
          sb.classList.add('curse-gift-sidebar--open', 'is-active');
          sb.style.setProperty('display', 'block', 'important');
        }
        try {
          document.body.classList.add('gift-panel-open');
        } catch (e) {}
      } else {
        if (sb) {
          sb.classList.remove('curse-gift-sidebar--open', 'is-active');
          sb.style.removeProperty('display');
        }
        if (drawer) drawer.classList.add('active');
        try {
          document.body.classList.add('curse-gift-open', 'gift-panel-open');
          document.documentElement.classList.add('curse-gift-open');
        } catch (e) {}
      }
      /* Mobilde hediye açıkken tier FAB gizli; masaüstünde yan panel + küçültülmüş Harcadıkça bir arada. */
      if (!isDesktopGift()) {
        setTierFabHiddenDuringGiftPanel(true);
      }
    } else {
      setTierFabHiddenDuringGiftPanel(false);
      root.classList.remove('curse-gift-panel-open');
      try {
        document.body.classList.remove('curse-gift-open', 'gift-panel-open');
        document.documentElement.classList.remove('curse-gift-open');
      } catch (e) {}
      if (sb) {
        sb.classList.remove('curse-gift-sidebar--open', 'is-active');
        sb.style.removeProperty('display');
      }
      if (drawer) drawer.classList.remove('active');
      purgeGiftPanelLocks();
    }
  }

  function getCartPageSectionsPayload() {
    var cartItemsEl = document.querySelector('cart-items');
    if (!cartItemsEl || typeof CartItems === 'undefined') return null;
    var sections = CartItems.prototype.getSectionsToRender.call(cartItemsEl);
    if (!sections || !sections.length) return null;
    return {
      sections: sections.map(function (s) {
        return s.section;
      }),
      sections_url: window.location.pathname
    };
  }

  function getSectionsPayload() {
    if (window.__CURSE_CART_PAGE__) {
      return getCartPageSectionsPayload();
    }
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return {
        sections: cartDrawer.getSectionsToRender().map(function (s) {
          return s.id;
        }),
        sections_url: window.location.pathname
      };
    }
    return null;
  }

  function fetchAndRenderCartPage() {
    var itemsEl = document.getElementById('main-cart-items');
    var sectionId = itemsEl && itemsEl.dataset.id;
    if (!sectionId) {
      window.location.reload();
      return Promise.resolve();
    }

    return nf(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId), {
      headers: { Accept: 'text/html' }
    })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cartItemsEl = document.querySelector('cart-items');
        if (!cartItemsEl || typeof CartItems === 'undefined') {
          window.location.reload();
          return;
        }
        var sections = CartItems.prototype.getSectionsToRender.call(cartItemsEl);
        sections.forEach(function (section) {
          var host = document.getElementById(section.id);
          var source = doc.getElementById(section.id);
          if (!host || !source) return;
          var target = host.querySelector(section.selector);
          var srcTarget = source.querySelector(section.selector);
          if (target && srcTarget) target.innerHTML = srcTarget.innerHTML;
        });
        try {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (eEv) {}
        queueMicrotask(function () {
          if (window.curseGiftSelector && typeof window.curseGiftSelector.scheduleCartSync === 'function') {
            window.curseGiftSelector.scheduleCartSync(0);
          }
        });
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function renderCartPage(state) {
    if (!state || !state.sections) {
      return fetchAndRenderCartPage();
    }

    var cartItemsEl = document.querySelector('cart-items');
    if (!cartItemsEl || typeof CartItems === 'undefined') {
      return fetchAndRenderCartPage();
    }

    var proto = CartItems.prototype;
    var sections = proto.getSectionsToRender.call(cartItemsEl);
    var updated = false;
    sections.forEach(function (section) {
      var host = document.getElementById(section.id);
      if (!host || !state.sections[section.section]) return;
      var target = host.querySelector(section.selector) || host;
      target.innerHTML = proto.getSectionInnerHTML.call(cartItemsEl, state.sections[section.section], section.selector);
      updated = true;
    });

    if (!updated) {
      return fetchAndRenderCartPage();
    }

    if (typeof state.item_count === 'number') {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.updateHeaderBubble) drawer.updateHeaderBubble(state.item_count);
    }

    try {
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (eEv) {}

    queueMicrotask(function () {
      if (window.curseGiftSelector && typeof window.curseGiftSelector.scheduleCartSync === 'function') {
        window.curseGiftSelector.scheduleCartSync(0);
      }
      if (window.__CURSE_CART_PAGE__ && window.__curseGiftPanelKeepOpen) {
        if (typeof window.curseCartReopenGiftPanel === 'function') {
          window.curseCartReopenGiftPanel();
        }
      }
    });
  }

  function renderCartDrawer(state) {
    if (window.__CURSE_CART_PAGE__) {
      renderCartPage(state);
      return;
    }
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function' && state && state.sections) {
      cartDrawer.renderContents(state);
    }
  }

  function loadCartJson() {
    skipGiftCartHook++;
    return nf('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .finally(function () {
        skipGiftCartHook--;
      });
  }

  function cartPostJSON(url, body) {
    skipGiftCartHook++;
    var merged =
      body && typeof body === 'object'
        ? Object.assign({}, body, getSectionsPayload() || {})
        : body || {};

    return nf(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(merged)
    })
      .then(function (r) {
        return r.json();
      })
      .finally(function () {
        skipGiftCartHook--;
      });
  }

  function enforceGiftRules(cart) {
    var thr = thresholdCents();
    var total = Number(cart.total_price != null ? cart.total_price : cart.items_subtotal_price || NaN);

    function dedupeAndClamp(doneCart) {
      var gifts = doneCart.items.filter(function (i) {
        return i.properties && i.properties._curse_gift === 'true';
      });

      if (gifts.length > 1) {
        var updates = {};
        for (var i = 1; i < gifts.length; i++) {
          updates[String(gifts[i].variant_id)] = 0;
        }
        return cartPostJSON('/cart/update.js', { updates: updates }).then(function (state) {
          renderCartDrawer(state);
          return loadCartJson().then(function (c2) {
            return dedupeAndClamp(c2);
          });
        });
      }

      if (gifts.length === 1 && gifts[0].quantity > 1) {
        return cartPostJSON('/cart/change.js', {
          id: gifts[0].key,
          quantity: 1
        }).then(function (state) {
          renderCartDrawer(state);
          return loadCartJson();
        });
      }

      return Promise.resolve(doneCart);
    }

    if (!Number.isFinite(total) || total < thr) {
      var removals = {};
      cart.items.forEach(function (item) {
        if (item.properties && item.properties._curse_gift === 'true') {
          removals[String(item.variant_id)] = 0;
        }
      });
      if (Object.keys(removals).length === 0) {
        return dedupeAndClamp(cart);
      }
      return cartPostJSON('/cart/update.js', { updates: removals }).then(function (state) {
        renderCartDrawer(state);
        return loadCartJson().then(function (c2) {
          return dedupeAndClamp(c2);
        });
      });
    }

    var premThr = premiumThresholdCents();
    if (Number.isFinite(total) && total < premThr) {
      var towelLines = cart.items.filter(function (item) {
        return (
          item.properties &&
          item.properties._curse_gift === 'true' &&
          String(item.variant_id) === CURSE_GIFT_TOWEL_ID
        );
      });
      if (towelLines.length) {
        var towelRemovals = {};
        towelRemovals[CURSE_GIFT_TOWEL_ID] = 0;
        return cartPostJSON('/cart/update.js', { updates: towelRemovals }).then(function (state) {
          renderCartDrawer(state);
          return loadCartJson().then(function (c2) {
            return dedupeAndClamp(c2);
          });
        });
      }
    }

    return dedupeAndClamp(cart);
  }

  function findSelectedGiftVariantId(cart) {
    var giftLine = cart.items.find(function (i) {
      return i.properties && i.properties._curse_gift === 'true';
    });
    return giftLine ? String(giftLine.variant_id) : null;
  }

  function syncGiftButtonsFromCart(cart) {
    var selectedId = findSelectedGiftVariantId(cart);
    var total = cartTotalCents(cart);
    var stdThr = thresholdCents();
    var premThr = premiumThresholdCents();

    function syncButtons(root) {
      if (!root) return;
      root.querySelectorAll('.curse-gift-item__select').forEach(function (btn) {
        var vid = String(btn.getAttribute('data-variant-id') || '');
        var tier = btn.getAttribute('data-gift-tier') || (isPremiumGiftVariant(vid) ? 'premium' : 'standard');
        var sel = selectedId && vid === selectedId;
        var label = btn.querySelector('.curse-gift-item__select-text');
        var locked =
          btn.getAttribute('data-locked') === 'true' ||
          (tier === 'premium' && total < premThr) ||
          (tier === 'standard' && total < stdThr);
        var card = btn.closest('.cc-gift-card');

        btn.classList.remove('is-loading');
        btn.classList.toggle('curse-gift-item__select--selected', sel);
        if (card) card.classList.toggle('is-locked', locked && !sel);

        if (label) {
          if (sel) {
            label.textContent = 'Seçildi';
          } else if (locked) {
            label.textContent = tier === 'premium' ? '8000 TL' : 'Kilitli';
          } else {
            label.textContent = 'Seç';
          }
        }

        btn.disabled = sel || locked;
      });

      root.querySelectorAll('.cc-gift-tier').forEach(function (tierEl) {
        var isPrem = tierEl.classList.contains('cc-gift-tier--premium');
        var ok = isPrem ? total >= premThr : total >= stdThr;
        tierEl.classList.toggle('cc-gift-tier--locked', !ok);
        var lockLabel = tierEl.querySelector('.cc-gift-tier__lock');
        if (lockLabel && !ok) {
          var need = isPrem ? premThr - total : stdThr - total;
          lockLabel.textContent = '🔒 ' + Math.ceil(need / 100).toLocaleString('tr-TR') + ' TL kaldı';
        }
      });
    }

    syncButtons(giftRoot());
    syncButtons(document.getElementById('curse-cart-gift-list'));
  }

  function cloneListToMobileDrawer() {
    var list = document.getElementById('curse-gift-list');
    var drawerList = document.getElementById('curse-gift-drawer-list');
    if (list && drawerList) {
      drawerList.innerHTML = list.innerHTML;
    }
  }

  /**
   * Önce tüm hediye satırlarını updates ile sıfırla; sonra quantity: 1 ile yeni hediye ekle.
   */
  function replaceCurseGiftWithVariant(variantId, clickedBtn) {
    var vidNew = String(variantId);
    var onCartPage = !!window.__CURSE_CART_PAGE__;

    try {
      if (onCartPage) {
        window.__curseGiftPanelShouldStayOpen = true;
        window.__curseGiftPanelKeepOpen = true;
      } else {
        window.__curseGiftPanelShouldStayOpen = false;
      }
    } catch (eP) {}

    if (clickedBtn) {
      clickedBtn.classList.add('is-loading');
    }

    _curseGiftReplacingBusy++;

    var updates = {};
    CURSE_GIFT_VARIANT_IDS.forEach(function (id) {
      updates[String(id)] = 0;
    });

    return cartPostJSON('/cart/update.js', { updates: updates })
      .then(function () {
        var thr = thresholdCents();
        var body = {
          items: [
            {
              id: Number(vidNew),
              quantity: 1,
              properties: {
                _curse_gift: 'true',
                _gift_threshold: String(thr / 100)
              }
            }
          ]
        };
        return cartPostJSON('/cart/add.js', body);
      })
      .then(function (data) {
        if (data && (data.status === 422 || data.status === 500)) {
          throw new Error(data.description || data.message || 'Sepete eklenemedi.');
        }
        renderCartDrawer(data);

        if (onCartPage) {
          return loadCartJson().then(function (c) {
            var total = Number(c.total_price != null ? c.total_price : c.items_subtotal_price || 0);
            var premThr = premiumThresholdCents();
            var towelLine = c.items.find(function (i) {
              return String(i.variant_id) === CURSE_GIFT_TOWEL_ID;
            });
            if (towelLine && total < premThr) {
              return cartPostJSON('/cart/update.js', { updates: { [CURSE_GIFT_TOWEL_ID]: 0 } }).then(function (state) {
                renderCartDrawer(state);
                return loadCartJson();
              });
            }
            return c;
          });
        }

        return loadCartJson().then(function (c) {
          return enforceGiftRules(c);
        });
      })
      .then(function (cart) {
        cloneListToMobileDrawer();
        syncGiftButtonsFromCart(cart);

        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.updateHeaderBubble && cart && typeof cart.item_count === 'number') {
          drawer.updateHeaderBubble(cart.item_count);
        }

        if (onCartPage) {
          if (typeof window.curseCartReopenGiftPanel === 'function') {
            window.curseCartReopenGiftPanel();
          }
          return cart;
        }

        setGiftActive(false);
        return cart;
      })
      .catch(function (err) {
        console.error('[Curse Hediye]', err);
        alert(err && err.message ? err.message : 'Hediye güncellenemedi.');
      })
      .finally(function () {
        _curseGiftReplacingBusy = Math.max(0, _curseGiftReplacingBusy - 1);
        if (_curseGiftReplacingBusy === 0) {
          try {
            queueMicrotask(function () {
              applyCartState({});
            });
          } catch (eQ) {}
        }
        if (clickedBtn) {
          clickedBtn.classList.remove('is-loading');
        }
      });
  }

  function sanitizeGiftCheckout() {
    return loadCartJson().then(function (cart) {
      var gifts = cart.items.filter(function (i) {
        return i.properties && i.properties._curse_gift === 'true';
      });

      return gifts.reduce(function (chain, g) {
        return chain.then(function () {
          if (g.quantity !== 1) {
            return cartPostJSON('/cart/change.js', { id: g.key, quantity: 1 }).then(function (state) {
              renderCartDrawer(state);
            });
          }
          return Promise.resolve();
        });
      }, Promise.resolve()).then(loadCartJson);
    });
  }

  /**
   * Sepet durumuna göre hediye paneli + mobil FAB.
   * — Eşik altı: panel kapanır.
   * — Masaüstü + eşik üstü + çekmece açık: panel otomatik açılır (buton gerekmez).
   * — Mobil: panel yalnız kullanıcı tetikler; FAB görünürlüğü ayrı.
   * @param {{ autoOpenDesktop?: boolean }} opts (geri uyumluluk; açılış artık masaüstünde her zaman eşik ile bağlı)
   */
  function applyCartState(opts) {
    if (_curseGiftReplacingBusy > 0) {
      return Promise.resolve();
    }
    if (_applyingCartUi) {
      _pendingApplyCartState = true;
      return Promise.resolve();
    }
    opts = opts || {};

    _applyingCartUi = true;
    _pendingApplyCartState = false;
    var keepPanelOpen = false;
    try {
      keepPanelOpen = window.__curseGiftPanelShouldStayOpen === true;
    } catch (eK) {}

    return loadCartJson()
      .then(function (cart) {
        return enforceGiftRules(cart);
      })
      .then(function (cart) {
        if (window.__CURSE_CART_PAGE__) {
          cloneListToMobileDrawer();
          syncGiftButtonsFromCart(cart);
          var drawerCp = document.querySelector('cart-drawer');
          if (drawerCp && drawerCp.updateHeaderBubble && typeof cart.item_count === 'number') {
            drawerCp.updateHeaderBubble(cart.item_count);
          }
          return;
        }

        if (window.__CURSE_HIDE_RETAIL_CART_PROMOS__) {
          cloneListToMobileDrawer();
          syncGiftButtonsFromCart(cart);
          setGiftActive(false);
          var wH = document.getElementById('curse-cart-gift-fab-wrap');
          var fH = document.getElementById('curse-cart-gift-fab');
          if (wH) wH.hidden = true;
          if (fH) fH.hidden = true;
          var sbH = giftRoot() && giftRoot().querySelector('.curse-gift-sidebar');
          if (sbH) sbH.style.removeProperty('display');
          return;
        }

        cloneListToMobileDrawer();
        syncGiftButtonsFromCart(cart);

        var totalCents = Number(cart.total_price != null ? cart.total_price : cart.items_subtotal_price || 0);
        var thr = thresholdCents();
        var eligible = Number.isFinite(totalCents) && totalCents >= thr;
        var open = isCartDrawerOpen();
        var desktop = isDesktopGift();

        if (!desktop) {
          var sbm = giftRoot() && giftRoot().querySelector('.curse-gift-sidebar');
          if (sbm) sbm.style.removeProperty('display');
        }

        if (open) {
          syncCurseCartDrawerWidth();
          requestAnimationFrame(syncCurseCartDrawerWidth);
          setTimeout(syncCurseCartDrawerWidth, 80);
          setTimeout(syncCurseCartDrawerWidth, 240);
          setTimeout(syncCurseCartDrawerWidth, 400);
        }

        var wrap = document.getElementById('curse-cart-gift-fab-wrap');
        var fab = document.getElementById('curse-cart-gift-fab');
        var giftPanelOpen = !!(giftRoot() && giftRoot().getAttribute('data-active') === 'true');
        var showMobileFab = open && !desktop && !giftPanelOpen;
        if (wrap) wrap.hidden = !showMobileFab;
        if (fab) fab.hidden = !showMobileFab;

        try {
          if (eligible) {
            sessionStorage.setItem('curseGiftOverThreshold', '1');
          } else {
            sessionStorage.removeItem('curseGiftOverThreshold');
          }
        } catch (e) {}

        if (!eligible || !open) {
          setGiftActive(false);
          var sbx = giftRoot() && giftRoot().querySelector('.curse-gift-sidebar');
          if (sbx) sbx.style.removeProperty('display');
          return;
        }

        if (desktop) {
          setGiftActive(true);
        }

        /* keepPanelOpen: hediye seçim AJAX sırasında tekrar açılıp — kapatıp titreşimi tetikliyordu */
        if (_curseGiftReplacingBusy === 0 && keepPanelOpen && eligible && open && !desktop) {
          setGiftActive(true);
        }

        var giftDominatesTier = false;
        try {
          giftDominatesTier =
            document.body.classList.contains('curse-gift-open') ||
            (!desktop && !!(giftRoot() && giftRoot().getAttribute('data-active') === 'true'));
        } catch (eT) {}

        if (eligible && open && !giftDominatesTier) {
          try {
            var tierUserMin = false;
            try {
              tierUserMin = sessionStorage.getItem('curseTierDrawerMinimized') === '1';
            } catch (e0) {}
            if (!tierUserMin) {
              var tierEl = document.getElementById('CartDrawer-TierDiscount');
              if (tierEl) {
                tierEl.classList.remove('tier-discount-bar--minimized', 'is-minimized', 'tier-discount-bar--user-hidden');
                tierEl.removeAttribute('aria-hidden');
                tierEl.style.removeProperty('display');
              }
              var clusterEl = document.getElementById('CartDrawer-TierDiscountFabCluster');
              if (clusterEl && typeof window.curseTierClusterClearInline === 'function') {
                clusterEl.classList.remove('is-visible');
                clusterEl.setAttribute('hidden', '');
                window.curseTierClusterClearInline(clusterEl);
              }
              document.body.classList.remove('curse-cart-tier-dismissed');
              sessionStorage.removeItem('curseTierDrawerMinimized');
              if (typeof window.initTierDiscountBar === 'function') {
                window.initTierDiscountBar(document.getElementById('CartDrawer') || document);
              }
            }
          } catch (err2) {}
        }
      })
      .catch(function (e) {
        console.warn('[Curse Hediye]', e);
      })
      .finally(function () {
        _applyingCartUi = false;
        if (_pendingApplyCartState) {
          _pendingApplyCartState = false;
          applyCartState(opts);
        }
      });
  }

  function openGiftPanelFromTrigger() {
    loadCartJson()
      .then(function (cart) {
        var thr = thresholdCents();
        var total = Number(cart.total_price != null ? cart.total_price : cart.items_subtotal_price || 0);
        if (!Number.isFinite(total) || total < thr) {
          var minTl = Math.ceil(thr / 100).toLocaleString('tr-TR', { maximumFractionDigits: 0 });
          alert('Hediye için sepet tutarınızın ' + minTl + ' TL üzerinde olması gerekir.');
          return;
        }
        cloneListToMobileDrawer();
        syncGiftButtonsFromCart(cart);
        setGiftActive(true);
        if (!isDesktopGift()) {
          var wrap = document.getElementById('curse-cart-gift-fab-wrap');
          var fabBtn = document.getElementById('curse-cart-gift-fab');
          if (wrap) wrap.hidden = true;
          if (fabBtn) fabBtn.hidden = true;
        }
      })
      .catch(function () {
        alert('Sepet bilgisi alınamadı.');
      });
  }

  var _curseGiftFabTapAt = 0;
  function openGiftFromFabEvent(e) {
    var fromFab = e.target.closest('#curse-cart-gift-fab-wrap, #curse-cart-gift-fab');
    var fromMilestone = e.target.closest('.curse-gift-progress-trigger.curse-gift-trigger');
    if (!fromFab && !fromMilestone) return;
    if (!isCartDrawerOpen()) return;
    var now = Date.now();
    if (now - _curseGiftFabTapAt < 380) return;
    _curseGiftFabTapAt = now;
    if (typeof e.cancelable === 'boolean' && e.cancelable) e.preventDefault();
    e.stopPropagation();
    openGiftPanelFromTrigger();
  }

  document.addEventListener('click', openGiftFromFabEvent, true);
  document.addEventListener(
    'touchstart',
    openGiftFromFabEvent,
    { capture: true, passive: false }
  );

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var m = e.target.closest('.curse-gift-progress-trigger.curse-gift-trigger');
    if (!m || !isCartDrawerOpen()) return;
    e.preventDefault();
    openGiftPanelFromTrigger();
  });

  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest('#curse-gift-drawer-close')) {
        if (typeof e.cancelable === 'boolean' && e.cancelable) e.preventDefault();
        e.stopPropagation();
        setGiftActive(false);
        applyCartState({});
        return;
      }
      if (e.target.closest('#curse-gift-drawer-overlay')) {
        if (typeof e.cancelable === 'boolean' && e.cancelable) e.preventDefault();
        e.stopPropagation();
        setGiftActive(false);
        applyCartState({});
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.curse-gift-item__select');
      if (!btn) return;
      var gr = giftRoot();
      var inCartList = btn.closest('#curse-cart-gift-list, .cc-gift-list, .cc-gift-tiers');
      if (!inCartList && (!gr || !gr.contains(btn))) return;
      if (btn.classList.contains('is-loading')) return;
      if (btn.classList.contains('curse-gift-item__select--selected')) return;
      if (btn.disabled || btn.getAttribute('data-locked') === 'true') return;
      if (!inCartList && !isCartDrawerOpen() && !window.__CURSE_CART_PAGE__) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      e.preventDefault();
      e.stopPropagation();

      btn.classList.add('is-loading');

      loadCartJson()
        .then(function (cart) {
          var total = cartTotalCents(cart);
          var tier = btn.getAttribute('data-gift-tier') || (isPremiumGiftVariant(variantId) ? 'premium' : 'standard');
          if (tier === 'premium' && total < premiumThresholdCents()) {
            throw new Error('Premium havlu hediyesi 8000 TL üzeri alışverişlerde açılır.');
          }
          if (tier === 'standard' && total < thresholdCents()) {
            throw new Error('Standart hediye 4000 TL üzeri alışverişlerde açılır.');
          }
          return replaceCurseGiftWithVariant(variantId, btn);
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          if (err && err.message) alert(err.message);
        });
    },
    true
  );

  /** Checkout — hediye adeti 1 (çekmece + /cart sayfası) */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var sub = e.submitter;
      if (!sub || sub.name !== 'checkout') return;

      var isDrawer = form.id === 'CartDrawer-Form';
      var isCartPage = form.id === 'cart';
      if (!isDrawer && !isCartPage) return;

      if (form.getAttribute('data-curse-gift-checkout-go') === '1') {
        form.removeAttribute('data-curse-gift-checkout-go');
        return;
      }
      e.preventDefault();
      e.stopPropagation();

      sanitizeGiftCheckout()
        .catch(function () {})
        .finally(function () {
          form.setAttribute('data-curse-gift-checkout-go', '1');
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(sub);
          } else {
            form.submit();
          }
        });
    },
    true
  );

  function bindCartDrawerObserver() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    _cartDrawerWasOpen = isCartDrawerOpen();
    var obs = new MutationObserver(function () {
      var open = isCartDrawerOpen();
      _cartDrawerWasOpen = open;

      if (open) {
        syncCurseCartDrawerWidth();
        requestAnimationFrame(syncCurseCartDrawerWidth);
      }

      if (!open) {
        setGiftActive(false);
        applyCartState({});
        return;
      }

      applyCartState({});
    });
    obs.observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  function bindPubSub() {
    var tryBind = function () {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        applyCartState({});
      });
    };
    tryBind();
    document.addEventListener('DOMContentLoaded', tryBind, { once: true });
  }

  document.addEventListener('cart:updated', function () {
    applyCartState({});
  });

  document.documentElement.addEventListener('cart:refresh', function () {
    queueMicrotask(function () {
      applyCartState({});
      syncCurseCartDrawerWidth();
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    curseGiftHydrateRoot();
    cloneListToMobileDrawer();
    _cartDrawerWasOpen = isCartDrawerOpen();
    syncCurseCartDrawerWidth();
    applyCartState({});
    bindCartDrawerObserver();
    bindPubSub();
  });

  window.addEventListener('resize', scheduleSyncCurseCartDrawerWidth, { passive: true });
  try {
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleSyncCurseCartDrawerWidth, { passive: true });
    }
  } catch (eVV) {}

  window.curseGiftSelector = {
    hydrateRoot: curseGiftHydrateRoot,
    refreshDomRefs: function () {
      curseGiftHydrateRoot();
      syncCurseCartDrawerWidth();
      loadCartJson()
        .then(function (c) {
          return enforceGiftRules(c);
        })
        .then(function (cart) {
          cloneListToMobileDrawer();
          syncGiftButtonsFromCart(cart);
        })
        .catch(function () {});
      applyCartState({});
    },
    scheduleCartSync: function (delay) {
      setTimeout(function () {
        applyCartState({});
      }, typeof delay === 'number' ? delay : 120);
    },
    syncGiftFab: function () {
      applyCartState({});
    },
    purgeBodyLocks: purgeGiftPanelLocks,
    closeDrawer: function () {
      setGiftActive(false);
      applyCartState({});
    },
    hidePanel: function () {
      setGiftActive(false);
      applyCartState({});
    }
  };

  if (!window.__curseGiftFetchHook) {
    window.__curseGiftFetchHook = true;
    window.fetch = function patchedFetch() {
      var args = arguments;
      var u = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url ? String(args[0].url) : '';
      var p = nf.apply(window, args);

      if (skipGiftCartHook > 0) return p;
      if (_curseGiftReplacingBusy > 0) return p;

      if (
        typeof u === 'string' &&
        (u.includes('/cart/add') || u.includes('/cart/update') || u.includes('/cart/change'))
      ) {
        p.then(function () {
          queueMicrotask(function () {
            applyCartState({});
          });
        }).catch(function () {});
      }

      return p;
    };
  }
})();
